import { render, staticRenderFns } from "./AppNav.vue?vue&type=template&id=0a95910a&scoped=true"
import script from "./AppNav.vue?vue&type=script&lang=js"
export * from "./AppNav.vue?vue&type=script&lang=js"
import style0 from "./AppNav.vue?vue&type=style&index=0&id=0a95910a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a95910a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a95910a')) {
      api.createRecord('0a95910a', component.options)
    } else {
      api.reload('0a95910a', component.options)
    }
    module.hot.accept("./AppNav.vue?vue&type=template&id=0a95910a&scoped=true", function () {
      api.rerender('0a95910a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/AppNav.vue"
export default component.exports